const controlDialog = () => {
 const DATA_TARGET = `modal-target`;
 const DATA_NAME = `modal-name`;

 const CLASS_NO_BACKDROP = `no-backdrop`;
 const CLASS_NO_APPEND = `no-append`;

 const SELECTOR_MODALS = `dialog`;
 const SELECTOR_CLOSE_BUTTON = `.modal-close`;

 let currentModal = null;

 // Trap focus
 const handleKeydown = (e) => {
 const isTabPressed = e.key === `Tab`;

 currentModal = e.target?.closest(`[data-${DATA_NAME}]`);

 if (!isTabPressed || !currentModal) return;

 const focusableElements = Array.from(
 currentModal.querySelectorAll(`a[href], button, textarea, input, select`),
 ).filter((el) => el.matches(':not([disabled]):not([tabindex="-1"])'));
 const firstFocusableElement = focusableElements[0];
 const lastFocusableElement =
 focusableElements[focusableElements.length - 1];

 if (e.shiftKey) {
 if (document.activeElement === firstFocusableElement) {
 lastFocusableElement.focus();
 e.preventDefault();
 }
 } else {
 if (document.activeElement === lastFocusableElement) {
 firstFocusableElement.focus();
 e.preventDefault();
 }
 }
 };

 const handleOpenModal = (e) => {
 const openTrigger = e.target.closest(`[data-${DATA_TARGET}]`);

 if (!openTrigger) return;

 openTrigger.tagName === `A` && e.preventDefault();
 openModal(openTrigger.getAttribute(`data-${DATA_TARGET}`));
 };

 const handleCloseModal = (e) => {
 const closeTrigger = e.target.closest(`${SELECTOR_CLOSE_BUTTON}`);

 if (!closeTrigger) return;

 closeTrigger.closest(SELECTOR_MODALS)?.close();
 };

 const openModal = (modalName) => {
 if (!modalName) return;

 const modals = document.querySelectorAll(`[data-${DATA_NAME}]`);

 modals.forEach((modal) => {
 const hasName =
 modal.matches(`[data-${DATA_NAME}~="${modalName}"]`) ||
 modalName === `all`;

 if (!hasName || modal.matches(`[open]`)) return;

 const method = modal.matches(`.${CLASS_NO_BACKDROP}`)
 ? `show`
 : `showModal`;
 const isNoAppend = modal.matches(`.${CLASS_NO_APPEND}`);

 method === `show` && !isNoAppend && document.body.appendChild(modal);
 modal[method]?.();

 modal.scrollLeft = 0;
 modal.scrollTop = 0;
 });
 };

 const closeModal = (modalName) => {
 if (!modalName) return;

 const modals = document.querySelectorAll(`[data-${DATA_NAME}]`);

 modals.forEach((modal) => {
 const hasName =
 modal.matches(`[data-${DATA_NAME}~="${modalName}"]`) ||
 modalName === `all`;

 if (!hasName) return;

 modal.close();
 });
 };

 const initialize = () => {
 document.body.addEventListener(`click`, handleOpenModal);
 document.body.addEventListener(`click`, handleCloseModal);
 document.body.addEventListener(`keydown`, handleKeydown);
 };

 initialize();

 controlDialog.open = openModal;

 controlDialog.close = closeModal;

 controlDialog.cleanup = () => {
 document.body.removeEventListener(`click`, handleOpenModal);
 document.body.removeEventListener(`click`, handleCloseModal);
 document.body.removeEventListener(`keydown`, handleKeydown);
 };
};

export default controlDialog;
